import type { DefaultTheme } from 'styled-components'

export function getInputBorderColor({
  $disabled = false,
  $error = false,
  $highlighted = false,
  theme,
  $isAdvancedAccounting = false,
}: {
  $disabled?: boolean
  $error?: boolean
  $highlighted?: boolean
  theme: DefaultTheme
  $isAdvancedAccounting?: boolean
}) {
  if ($error) {
    return theme.colors.error[150]
  }

  if ($disabled) {
    return theme.colors.field.disabledBorder
  }

  if ($highlighted) {
    if ($isAdvancedAccounting) {
      return theme.colors.common.purple
    }

    return theme.colors.primary[50]
  }

  return theme.colors.field.border
}
